import React from 'react';

const LandingPage = () => (
  <div>
    <h1>LandingPage</h1>
  </div>
);

export default LandingPage;
